import { useState } from "react";
import ChatBot from "react-chatbotify";
import styled from "@emotion/styled";
import React from "react";
import heartIcon from "../Assets/images/heart.svg";
import botAvatar from "../Assets/Chatbot/botAvatar.svg";
import { Button } from "react-chatbotify";

const ChatIconSVG = () => (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  );
  const HeartImage = styled.img`
  width: 1rem;
  height: 1rem;
`;

export const Settings = {
  general: {
    primaryColor: "#F4511E",
    secondaryColor: "#BF4823",
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', " +
      "'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', " +
      "sans-serif",
    showHeader: true,
    showFooter: true,
    showInputRow: true,
    // actionDisabledIcon: actionDisabledIcon,
    embedded: false,
    flowStartTrigger: "ON_LOAD",
  },
  header: {
    title: (
      <div
        style={{
          cursor: "pointer",
          margin: 0,
          fontSize: 20,
          fontWeight: "bold",
        }}
      >
        Code8
      </div>
    ),
    buttons: [
      Button.NOTIFICATION_BUTTON,
      Button.AUDIO_BUTTON,
      Button.CLOSE_CHAT_BUTTON,
    ],
    showAvatar: true,
		avatar: botAvatar,
  },
  tooltip: {
    mode: "CLOSE",
    text: "Need Help! 😊",
  },
  chatButton: {
    icon: ChatIconSVG,
  },
  chatHistory: {
    disabled: false,
    maxEntries: 30,
    storageKey: "rcb-history",
    storageType: "LOCAL_STORAGE",
    viewChatHistoryButtonText: "Load Chat History ⟳",
    chatHistoryLineBreakText: "----- Previous Chat History -----",
    autoLoad: false,
  },
  botBubble: {
		simulateStream: false,
	},
  
  footer: {
    text: (
      <div
        style={{
          cursor: "pointer",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          columnGap: 3,
        }}
        // onClick={() => window.open("https://react-chatbotify.com")}
      >
        <span key={0}>Made with </span>
        <div
          key={1}
          style={{
            borderRadius: "50%",
            width: 14,
            height: 14,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // background: "linear-gradient(to right, #42b0c5, #491d8d)",
          }}
        >
          <HeartImage src={heartIcon} alt="Love" />
        </div>
      </div>
    ),
    // buttons: [Button.FILE_ATTACHMENT_BUTTON, Button.EMOJI_PICKER_BUTTON]
    buttons: [Button.EMOJI_PICKER_BUTTON],
  },
};
// 